export default function () {
  return [
    // Dashboard
    {
      title: 'Painel de controle',
      name: 'dashboard',
      to: {
        name: 'admin-overview',
      },
      htmlBefore: '<i class="material-icons">dashboard</i>',
    },
    // Leads
    {
      title: 'Indicações',
      name: 'leads',
      to: {
        name: 'admin-lead-list',
        params: {
          page: 1,
        },
      },
      htmlBefore: '<i class="material-icons">location_on</i>',
    },
    // Distributors
    {
      title: 'Distribuidores',
      name: 'resellers',
      htmlBefore: '<i class="material-icons">record_voice_over</i>',
      to: {
        name: 'admin-distributor-list',
        params: {
          page: 1,
        },
      },
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-distributor-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Adicionar',
          to: {
            name: 'admin-distributor-new',
          },
        },
      ],
    },
    // Supervisors
    {
      title: 'Supervisores',
      name: 'supervisors',
      htmlBefore: '<i class="material-icons">supervisor_account</i>',
      to: {
        name: 'admin-supervisor-list',
        params: {
          page: 1,
        },
      },
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-supervisor-list',
            params: {
              page: 1,
            },
          },
        },
      ],
    },
    // Managers
    {
      title: 'Gerentes',
      name: 'managers',
      htmlBefore: '<i class="material-icons">supervisor_account</i>',
      to: {
        name: 'admin-manager-list',
        params: {
          page: 1,
        },
      },
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-manager-list',
            params: {
              page: 1,
            },
          },
        },
      ],
    },
    // Regions
    {
      title: 'Regiões',
      name: 'regions',
      htmlBefore: '<i class="material-icons">map</i>',
      to: {
        name: 'admin-region-list',
        params: {
          page: 1,
        },
      },
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-region-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Adicionar',
          to: {
            name: 'admin-region-new',
          },
        },
      ],
    },
    {
      title: 'Usuários',
      name: 'users',
      to: {
        name: 'admin-user-list',
        params: {
          page: 1,
        },
      },
      htmlBefore: '<i class="material-icons">perm_identity</i>',
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-user-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Adicionar',
          to: {
            name: 'admin-user-new',
          },
        },
      ],
    },
  ];
}
